import {Arguments} from './Arguments';
import {PostApiMethod, PostToJava} from './ApiMethod';
import {aesEncrypt} from './EncodeDecodeMethod';
import {message} from 'antd';

export const handleChangePassword = (oldPassword, newPassword) => {
	// 后台修改密码的接口
	const changePasswordApi = Arguments.host + '/society_organization/changePassword/api!changePassword.do';
	const userToken = sessionStorage.getItem('userToken');
	// 向用户中心发送修改密码请求
	const objData = {
		oldPassword: oldPassword,
		newPassword: newPassword,
		token: userToken,
	};
	// 如果要将 axios POST 请求的请求体格式设置为  application/x-www-form-urlencoded ，可以使用 qs 库将数据格式化为 URL 编码的形式。
	// 这样在 java 后端中就可以使用 String username = request.getParameter("username"); 获取传递的值了
	return PostToJava(changePasswordApi, objData).then(res => {
		if (res?.data.code === 1) {
			// console.log("密码修改成功");
			// 更新 sessionStorage 中保存的密码
			sessionStorage.setItem('shadow', aesEncrypt(newPassword));
		} else {
			// console.log("密码修改失败：" + res.data.result)
			message.error('密码修改失败：' + res?.data.result);
		}
		return res;
	});
};

export const handleResetPassword = (nickname, userName, password) => {
	// 用户中心重置密码接口
	const resetPasswordApi = Arguments.host + '/society_organization/changePassword/api!resetPassword.do';
	const userToken = sessionStorage.getItem('userToken');
	// 向用户中心发送重置密码请求
	const objData = {
		nickname: nickname,
		userName: userName,
		password: password,
		token: userToken,
	};
	// 如果要将 axios POST 请求的请求体格式设置为  application/x-www-form-urlencoded ，可以使用 qs 库将数据格式化为 URL 编码的形式。
	// 这样在 java 后端中就可以使用 String username = request.getParameter("username"); 获取传递的值了
	return PostToJava(resetPasswordApi, objData).then(res => {
		if (res?.data.code === '1') {
			// console.log("密码修改成功");
			// 更新 sessionStorage 中保存的密码
			sessionStorage.setItem('shadow', aesEncrypt(password));
		} else {
			// console.log("密码修改失败：" + res.data.result)
			message.error('密码修改失败：' + res?.data.result);
		}
		return res;
	});
};

export const updateUserDB = (newObjData) => {
	// 更新 user_info 表的接口
	const userInfoApi = Arguments.host + '/society_organization/policy/api!addUser.do';
	PostApiMethod(userInfoApi, newObjData);
};